"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var initialState = null;

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    if (action.sync && action.modified) {
        return action.modified;
    }
    return state;
};


//////////////////
// WEBPACK FOOTER
// ./src/client/reducers/lastSavedReducer.js
// module id = 2042
// module chunks = 0